import { Box, Button, Center, Loader, Menu, Text } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { DS_AI_MENU_PROPS } from '../primitives/dropdownMenu.styles';
import { BatchSummary } from './BatchSummary';
import { useDealBatchesMenuController } from './useDealBatchesMenuController';

interface Props {
	dealId: string;
}

const MENU_WIDTH = 320;

/** Transactions tab entry: the deal's DealStack AI batches, each opening its workspace. */
export const DealBatchesMenu = ({ dealId }: Props) => {
	const tCapManage = useTranslationCapManage();
	const { items, openBatch } = useDealBatchesMenuController(dealId);

	return (
		<Menu {...DS_AI_MENU_PROPS} width={MENU_WIDTH}>
			<Menu.Target>
				<Button
					size="height-36"
					variant="default"
					leftSection={<IconSparkles size={16} stroke={1.5} />}
					rightSection={<Icon variant="caret-down" size="lg" />}
					data-testid={TEST_ELEMENT_IDS.DEALSTACK_AI_DEAL_BATCHES_MENU}
				>
					{tCapManage('dealstack_ai.deal_batches.trigger')}
				</Button>
			</Menu.Target>
			<Menu.Dropdown>
				{items === undefined && (
					<Center p="xs">
						<Loader size="xs" />
					</Center>
				)}
				{items?.length === 0 && (
					<Text size="md" c="dark.0" p="xs">
						{tCapManage('dealstack_ai.deal_batches.empty')}
					</Text>
				)}
				<Box mah="360px" style={{ overflowY: 'auto' }}>
					{items?.map((item) => (
						<Menu.Item
							key={item.batch.id}
							disabled={item.path === null}
							onClick={() => openBatch(item)}
							data-testid={`${TEST_ELEMENT_IDS.DEALSTACK_AI_DEAL_BATCHES_ITEM}_${item.batch.id}`}
						>
							<BatchSummary item={item} />
						</Menu.Item>
					))}
				</Box>
			</Menu.Dropdown>
		</Menu>
	);
};
